import {
    Column,
    DivRendererOptions,
    Row,
    Sort,
    SortOrder,
} from '../grid/experimental.grid';
import { ExpandableRow } from '../grid/reusable-grid.model';

import { FocusSelectorBehaviourModel } from './focus-selector-behaviour.model';
import {
    BehaviourMedal,
    FocusSelectorSubBehaviourModel,
} from './focus-selector-subbehaviour.model';

export enum ColumnID {
    RANK = 'rank',
    FOCUS = 'focus',
    PROJECTED_15_DAY_IMPROVEMENT = 'projected_15_day_improvement',
    PROJECTED_30_DAY_IMPROVEMENT = 'projected_30_day_improvement',
    PROJECTED_60_DAY_IMPROVEMENT = 'projected_60_day_improvement',
}

export enum TemplateID {
    HEADER = 'header',
    CONTENT = 'content',
}

export interface CellContext {
    id?: number;
    rank?: number;
    medal?: BehaviourMedal;
    focus?: string;
    projected15?: number;
    projected30?: number;
    projected60?: number;
}

export interface RowContext {
    templateId: TemplateID;
    cellContext: CellContext;
}

export interface SubBehaviourCellContext extends CellContext {
    templateId: TemplateID;
    checked?: boolean;
}

export interface BehaviourRow
    extends Omit<ExpandableRow<RowContext, BehaviourCellContext>, 'children'> {
    children?: Array<Row<RowContext, SubBehaviourCellContext>>;
}

export interface BehaviourCellContext extends CellContext {
    templateId: TemplateID;
}

export interface FocusSelectionGrid {
    columns: Column[];
    rows: BehaviourRow[];
    sortDefs: Sort[];
    defaultSortDefs: Sort[];
    gridRowsTop: BehaviourRow[];
    rendererOpts: DivRendererOptions;
    selection?: {
        behaviourId: FocusSelectorBehaviourModel['id'];
        subBehaviourId: FocusSelectorSubBehaviourModel['id'];
    };
    filterByBehaviourId?: FocusSelectorBehaviourModel['id'];
}

export const defaultSortDefs: Sort[] = [
    {
        columnId: ColumnID.RANK,
        order: SortOrder.ASC,
    },
    {
        columnId: ColumnID.FOCUS,
        order: SortOrder.ASC,
    },
    {
        columnId: ColumnID.PROJECTED_15_DAY_IMPROVEMENT,
        order: SortOrder.ASC,
    },
    {
        columnId: ColumnID.PROJECTED_30_DAY_IMPROVEMENT,
        order: SortOrder.ASC,
    },
    {
        columnId: ColumnID.PROJECTED_60_DAY_IMPROVEMENT,
        order: SortOrder.ASC,
    },
];
